var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7445 3.26482H3.27102C2.70471 3.26482 2.16159 3.48978 1.76115 3.89022C1.36071 4.29067 1.13574 4.83378 1.13574 5.40009V20.347C1.13574 20.9133 1.36071 21.4564 1.76115 21.8569C2.16159 22.2573 2.70471 22.4823 3.27102 22.4823H18.2179C18.7842 22.4823 19.3274 22.2573 19.7278 21.8569C20.1282 21.4564 20.3532 20.9133 20.3532 20.347V12.8736",
    stroke: "#D15D36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7517 1.66334C19.1764 1.23861 19.7525 1 20.3531 1C20.9538 1 21.5299 1.23861 21.9546 1.66334C22.3793 2.08808 22.6179 2.66414 22.6179 3.2648C22.6179 3.86546 22.3793 4.44152 21.9546 4.86626L11.8121 15.0088L7.5415 16.0764L8.60914 11.8059L18.7517 1.66334Z",
    stroke: "#D15D36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.a92e24b1efbc21cf0b6f76c8edf9759d.svg";
export { ForwardRef as ReactComponent };